module.exports = __webpack_public_path__ + "img/enterprisedoc.230556f3.svg";